import React from 'react';

const daysOfWeek = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];
const weeksOfMonth = ['First','Second','Third','Fourth','Last'];

export default function RecurrenceFields({
  form,
  onChange,
  forceOccurrence = false,
  lockedOccurrenceDate = '',
  locked = false,
}) {
  if (forceOccurrence) {
    return (
      <div className="form-grid">
        <div className="form-field">
          <span className="field-label">Occurrence date</span>
          <input
            id="date"
            name="date"
            type="date"
            value={lockedOccurrenceDate || form.date || ''}
            onChange={onChange}
            className="input"
            disabled
          />
          <small className="text-muted">This override applies to this occurrence only.</small>
        </div>
        <div className="form-field">
          <label className="field-label" htmlFor="time">Time</label>
          <input id="time" name="time" type="time" value={form.time} onChange={onChange} className="input" required />
        </div>
      </div>
    );
  }

  if (form.type === 'oneOff') {
    return (
      <div className="form-grid">
        <div className="form-field">
          <span className="field-label">Date</span>
          <input id="date" name="date" type="date" value={form.date} onChange={onChange} className="input" required />
        </div>
        <div className="form-field">
          <label className="field-label" htmlFor="time">Time</label>
          <input id="time" name="time" type="time" value={form.time} onChange={onChange} className="input" required />
        </div>
      </div>
    );
  }

  return (
    <div className="form-grid">
      <div className="form-field">
        <span className="field-label">Day of Week</span>
        <select id="dayOfWeek" name="dayOfWeek" value={form.dayOfWeek} onChange={onChange} className="input" disabled={locked}>
          {daysOfWeek.map(day => <option key={day} value={day}>{day}</option>)}
        </select>
      </div>

      <div className="form-field">
        <label className="field-label" htmlFor="time">Time</label>
        <input id="time" name="time" type="time" value={form.time} onChange={onChange} className="input" required />
      </div>

      <div className="form-field">
        <span className="field-label">Frequency</span>
        <select id="frequency" name="frequency" value={form.frequency} onChange={onChange} className="input" disabled={locked}>
          <option value="WEEKLY">Weekly</option>
          <option value="MONTHLY">Monthly</option>
        </select>
      </div>

      <div className="form-field">
        <label className="field-label" htmlFor="recurrenceInterval">Repeat every</label>
        <select id="recurrenceInterval" name="recurrenceInterval" value={form.recurrenceInterval || 1} onChange={onChange} className="input" disabled={locked}>
          {Array.from(new Set([1, 2, 3, 4, 6, 12, Number(form.recurrenceInterval) || 1])).sort((a, b) => a - b).map(count => (
            <option key={count} value={count}>{count} {form.frequency === 'MONTHLY' ? (count === 1 ? 'month' : 'months') : (count === 1 ? 'week' : count === 2 ? 'weeks (fortnightly)' : 'weeks')}</option>
          ))}
        </select>
      </div>
      <div className="form-field">
        <label className="field-label" htmlFor="recurrenceStartDate">Starts</label>
        <input id="recurrenceStartDate" name="recurrenceStartDate" type="date" value={form.recurrenceStartDate || ''} onChange={onChange} className="input" required={Number(form.recurrenceInterval) > 1} disabled={locked} />
        <small className="text-muted">Sets the first week or month of the repeating schedule.</small>
      </div>

      {form.frequency === 'MONTHLY' && (
        <div className="form-field">
          <span className="field-label">Which Week</span>
          <select id="weekOfMonth" name="weekOfMonth" value={form.weekOfMonth} onChange={onChange} className="input" disabled={locked}>
            {weeksOfMonth.map(w => <option key={w} value={w}>{w}</option>)}
          </select>
        </div>
      )}

      <div className="form-field">
        <span className="field-label">Ends</span>
        <input
          id="recurrenceEndDate"
          name="recurrenceEndDate"
          type="date"
          value={form.recurrenceEndDate || ''}
          onChange={onChange}
          className="input"
          placeholder="Optional end date"
          disabled={locked}
        />
        <small className="text-muted">{locked ? 'The recurrence pattern and end date are locked because tickets have been sold.' : 'Leave blank for no end date (shows limited future occurrences).'}</small>
      </div>
    </div>
  );
}
